export const CheckIcon = defineComponent({
  setup() {
    return () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.1942 2.80082C16.5683 3.12813 16.6062 3.69672 16.2789 4.07079L8.72352 12.7055C7.92359 13.6197 6.51716 13.6665 5.65819 12.8076L2.36517 9.51453C2.01369 9.16306 2.01369 8.59321 2.36517 8.24174C2.71664 7.89027 3.28649 7.89027 3.63796 8.24174L6.93098 11.5348C7.05369 11.6575 7.25461 11.6508 7.36888 11.5202L14.9242 2.88548C15.2516 2.51141 15.8201 2.4735 16.1942 2.80082Z"
          fill="var(--colors-bg-icon-primary)"
        />
      </svg>
    )
  },
})

export const Check2Icon = defineComponent({
  setup() {
    return () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
        <rect x="-0.00390625" y="0.941162" width="18" height="18" rx="9" fill="#C63547" />
        <path
          d="M14.4013 7.75954L8.51754 14.3596C8.451 14.4525 8.36328 14.5281 8.26165 14.5803C8.16003 14.6325 8.04743 14.6598 7.93318 14.6598C7.81893 14.6598 7.70633 14.6325 7.60471 14.5803C7.50308 14.5281 7.41537 14.4525 7.34882 14.3596L4.53118 10.4542C4.51137 10.4273 4.49944 10.3953 4.4967 10.362C4.49396 10.3287 4.50053 10.2952 4.51567 10.2654C4.53081 10.2355 4.55393 10.2105 4.58246 10.193C4.61099 10.1755 4.64381 10.1663 4.67727 10.1664H5.7375C5.96893 10.1664 6.1859 10.2778 6.32331 10.4673L7.93173 12.7005L12.6092 7.77255C12.6762 7.67989 12.7642 7.60443 12.866 7.55238C12.9679 7.50034 13.0806 7.47318 13.195 7.47314H14.2552C14.4013 7.47314 14.4866 7.63948 14.4013 7.75954Z"
          fill="white"
        />
      </svg>
    )
  },
})

export const CheckCircleGreenIcon = defineComponent({
  setup() {
    return () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
        <rect width="11.3333" height="11.3333" rx="5.66667" fill="#34C759" />
        <path
          d="M9.07002 4.29301L5.36544 8.4486C5.32354 8.50707 5.26831 8.55472 5.20432 8.58759C5.14034 8.62046 5.06944 8.6376 4.99751 8.6376C4.92557 8.6376 4.85468 8.62046 4.79069 8.58759C4.7267 8.55472 4.67147 8.50707 4.62958 8.4486L2.85551 5.98967C2.84304 5.9727 2.83552 5.95259 2.8338 5.9316C2.83207 5.9106 2.83621 5.88954 2.84574 5.87076C2.85527 5.85197 2.86983 5.8362 2.8878 5.8252C2.90576 5.8142 2.92642 5.8084 2.94749 5.80844H3.61504C3.76076 5.80844 3.89736 5.87857 3.98388 5.99787L4.9966 7.40401L7.94164 4.30121C7.98384 4.24286 8.03927 4.19535 8.10339 4.16258C8.1675 4.12981 8.23848 4.11271 8.31048 4.11269H8.97804C9.07002 4.11269 9.12375 4.21742 9.07002 4.29301Z"
          fill="white"
        />
      </svg>
    )
  },
})
